export const BASE_URL = import.meta.env.VITE_LOCAL_API_URL;
export const CLIENT_URL = import.meta.env.VITE_CLIENT_API_URL;
